import { FC, ReactNode, useEffect } from 'react';

import { css } from '@emotion/react';
import { ToucanColors, ToucanComponents } from '@jointoucan/toucan-design';
import { Table, TableRow, TableCell, TableBody, Box } from '@mui/material';

import { useDoctorContext } from './DoctorContext';

const { Card, Typography, ToucanIcon } = ToucanComponents;

interface DoctorCardProps {
  beforeContent?: ReactNode;
  title: string;
  asideContent?: ReactNode;
  rows: Array<{ label: string; value: string | boolean }>;
}

export const DoctorCard: FC<DoctorCardProps> = ({ beforeContent, title, asideContent, rows }) => {
  const { addRows } = useDoctorContext();

  useEffect(() => {
    const flattenedRows = rows.map((row) => ({ ...row, value: row.value.toString() }));
    addRows(flattenedRows);
  }, rows);

  return (
    <Card hasPadding={false}>
      {beforeContent}
      <Box pl={2} pt={3} pb={2} display="flex" alignItems="center" minWidth="416px">
        <Box flex="1">
          <Typography color={ToucanColors.gray[400]} variant="md" isBold>
            {title}
          </Typography>
        </Box>
        <Box flex="0" pr={2}>
          {asideContent}
        </Box>
      </Box>
      <Box pb={1}>
        <Table>
          <TableBody>
            {rows.map(({ label, value }) => {
              return (
                <TableRow key={label}>
                  <TableCell>
                    <strong>{label}</strong>
                  </TableCell>
                  <TableCell align="left">
                    {typeof value === 'string' ? (
                      value
                    ) : (
                      <ToucanIcon
                        icon={value ? 'check' : 'times'}
                        css={css`
                          color: ${value ? ToucanColors.green[300] : ToucanColors.red[300]};
                        `}
                      />
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    </Card>
  );
};
